export default "Ver. 0.4.1( 2026-05-11 )\n"